import { useNavigate } from 'react-router-dom';
import ModalWrapper from 'components/common/overlays/ModalWrapper';
import SingleBtn from 'components/common/elements/SingleBtn';
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import styles from 'styles/pages/modal/ScoreDatail.module.scss';
import { TScoreDetailParams, TScoreDetailResponse } from 'types/apis/score';
import useModal from 'hooks/useModal';

type TProps = {
  data: TScoreDetailResponse;
  params: TScoreDetailParams | null;
  onClose: () => void;
};

const ScoreDatail = ({ data, params, onClose }: TProps) => {
  const navigate = useNavigate();

  const { closeModal } = useModal();

  const handleClose = () => {
    closeModal();
    onClose();
  };

  return (
    <ModalWrapper>
      <div className="flex justify_between items_center">
        <h2 className="main_title mb8">
          {data.summaryInfo?.courseName && `${data.summaryInfo.courseName} - `}
          {data.summaryInfo?.chartRound && `(${data.summaryInfo.chartRound}차)`}
          {data.summaryInfo?.chartName && data.summaryInfo.chartName}
        </h2>
        <button type="button" onClick={handleClose}>
          <CloseIcon alt="close" fill={STYLES_VARIABLES.GRAY_07} />
        </button>
      </div>
      <div className="flex justify_end">
        <p className={styles.text}>
          학생명 : {data.summaryInfo?.name || '-'}{' '}
          {data.summaryInfo?.loginId && `(${data.summaryInfo.loginId})`}
        </p>
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>차트 종류</th>
            <th>1차 점수</th>
            <th>2차 점수</th>
          </tr>
        </thead>
        <tbody>
          {data.scoreList.map((list, index) => (
            <tr key={index}>
              <td>{list.chartTypeName}</td>
              <td>{list.firstScore}</td>
              <td>{list.secondScore}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <SingleBtn
        btnText="차트 평가하러 가기"
        isBtnActive={true}
        btnStyle={{
          width: '100%',
          marginTop: '20px',
          fontSize: '14px',
        }}
        onClick={() =>
          navigate(
            `/student${params?.userId ? `/${params.userId}` : ''}${
              params?.courseInfoId && params?.chartRound
                ? `?courseInfoId=${params.courseInfoId}&chartRound=${params.chartRound}`
                : ''
            }`
          )
        }
      />
    </ModalWrapper>
  );
};

export default ScoreDatail;
